require("core-js/modules/esnext.global-this.js");
!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("classToggler", [], e) : "object" == typeof exports ? exports.classToggler = e() : t.classToggler = e();
}(this, function () {
  return function () {
    var t = {
        895: function _(t, e, o) {
          var n, r, i;
          void 0 !== o.g ? o.g : this.window || this.global, r = [], void 0 === (i = "function" == typeof (n = function () {
            "use strict";

            var t = {},
              e = "data-toggle",
              o = "data-toggle-self",
              n = "click",
              r = function r(t) {
                t.addEventListener(n, i), t.getAttribute(o) && t.addEventListener(n, function () {
                  t.classList.toggle(t.getAttribute(o));
                });
              },
              i = function i(t) {
                var o = t.currentTarget.getAttribute(e),
                  n = t.currentTarget.getAttribute("data-toggle-class"),
                  r = document.getElementsByClassName(o);
                r.length > 0 ? (r[0].classList.toggle(n), t.stopPropagation()) : console.warn("classToggler error: Cannot find element with class " + o);
              };
            return t.init = function () {
              for (var t = document.querySelectorAll("[" + e + "]"), o = 0; o < t.length; o++) r(t[o]);
            }, t;
          }()) ? n.apply(e, r) : n) || (t.exports = i);
        }
      },
      e = {};
    function o(n) {
      var r = e[n];
      if (void 0 !== r) return r.exports;
      var i = e[n] = {
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, o), i.exports;
    }
    return o.g = function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    }(), o(895);
  }();
});